/** 参考线支持的方向。 */
export type ReferenceLineDirection = 'horizontal' | 'vertical';

/** 参考线持久化及历史记录使用的数据结构。 */
export type ReferenceLine = {
    /** 参考线唯一标识，用于更新、删除和历史记录匹配。 */
    id: string;
    /** 参考线方向。 */
    direction: ReferenceLineDirection;
    /** 参考线在编辑器坐标系中的位置，单位为逻辑像素。 */
    position: number;
};

/** reference-lines 写入单条舞台历史的精确快照。 */
export type ReferenceLinesStageHistoryExtension = {
    /** 舞台尺寸调整开始时的参考线深拷贝。 */
    oldLines: ReferenceLine[];
    /** 舞台尺寸调整写历史时的参考线深拷贝。 */
    newLines: ReferenceLine[];
};

/** 参考线历史操作使用的稳定类型名。 */
export const ReferenceLineHistoryType = {
    /** 新增参考线。 */
    ADD: 'add-reference-line-action',
    /** 清空参考线。 */
    CLEAR: 'clear-reference-lines-action',
    /** 删除参考线。 */
    DELETE: 'del-reference-line-action',
    /** 锁定或解锁参考线。 */
    LOCK: 'lock-reference-lines-action',
    /** 显示或隐藏参考线。 */
    SHOW: 'show-reference-lines-action',
    /** 更新参考线。 */
    UPDATE: 'update-reference-line-action',
};

export type IHistoryAddData = {
    /** 新增的参考线。 */
    item: ReferenceLine;
};

export type IHistoryClearData = {
    /** 清空前的参考线列表。 */
    item: ReferenceLine[];
};

export type IHistoryDeleteData = {
    /** 被删除的参考线。 */
    item: ReferenceLine;
};

export type IHistoryLockData = {
    /** 参考线是否锁定。 */
    lock: boolean;
};

export type IHistoryShowData = {
    /** 参考线是否显示。 */
    show: boolean;
};

export type IHistoryUpdateData = {
    /** 更新前的参考线。 */
    oldInfo: ReferenceLine;
    /** 更新后的参考线。 */
    newInfo: ReferenceLine;
};
